import Relatorio from "../../../../models/Relatorio";
import Esqueleto from "../../../components/Esqueleto";
import { Kpis } from "../painel";
import { numero, useRelatorio } from "../useRelatorio";

export function Kpi({ valor, rotulo, detalhe, atencao }) {
  return (
    <div className={`kpi${atencao ? " atencao" : ""}`}>
      <span className="valor">{valor === null || valor === undefined ? "—" : numero(valor)}</span>
      <span className="rotulo">{rotulo}</span>
      {detalhe && <span className="detalhe">{detalhe}</span>}
    </div>
  );
}

// Faixa de números gerais da plataforma (GET /relatorios/resumo).
//
// Sozinha, consulta o backend. Se quem a usa já buscou o resumo (o Painel
// reparte uma única consulta entre vários blocos), passa `externo` e nada é
// pedido de novo. `semPendencias` omite o grupo de pedidos, que o Painel mostra
// em destaque.
export default function ResumoKpis({ externo, semPendencias = false }) {
  const proprio = useRelatorio(Relatorio.resumo, {}, !externo);
  const { dados, erro, carregando } = externo || proprio;

  if (carregando && !dados) return <Kpis><Esqueleto variante="texto" quantidade={1} rotulo="Carregando números gerais" /></Kpis>;
  if (erro) return <Kpis><span className="erro" role="alert">{erro}</span></Kpis>;
  if (!dados) return null;

  const { usuarios: u, plantios: p, solicitacoes_profissional: s } = dados;

  return (
    <Kpis aria-label="Números gerais da plataforma">
      <div className="grupo">
        <h3>Usuários</h3>
        <div className="grade">
          <Kpi valor={u.total} rotulo="Usuários cadastrados"
            detalhe={`${numero(u.ativos)} ativos · ${numero(u.inativos)} inativos · ${numero(u.aguardando_confirmacao)} aguardando confirmação`} />
          <Kpi valor={u.comuns} rotulo="Comuns" />
          <Kpi valor={u.profissionais} rotulo="Profissionais" />
          <Kpi valor={u.administradores} rotulo="Administradores" />
          <Kpi valor={u.novos_7_dias} rotulo="Novos em 7 dias" />
          <Kpi valor={u.novos_30_dias} rotulo="Novos em 30 dias" />
        </div>
      </div>

      <div className="grupo">
        <h3>Plantios</h3>
        <div className="grade">
          <Kpi valor={p.total} rotulo="Plantios registrados" detalhe={`${numero(p.ultimos_30_dias)} nos últimos 30 dias`} />
          <Kpi valor={p.individuais} rotulo="Individuais" />
          <Kpi valor={p.areas} rotulo="Áreas (Profissional)" />
          <Kpi valor={p.mudas} rotulo="Mudas plantadas" />
          <Kpi valor={p.plantadores} rotulo="Pessoas que plantaram" />
          <Kpi valor={p.estados_atendidos} rotulo="Estados com plantio" />
          <Kpi valor={p.cidades_atendidas} rotulo="Cidades com plantio" />
        </div>
      </div>

      {!semPendencias && (
        <div className="grupo">
          <h3>Pendências</h3>
          <div className="grade">
            <Kpi valor={s.pendentes} rotulo="Pedidos de perfil Profissional"
              detalhe={s.pendentes > 0 ? "Aguardando resposta em Pedidos de perfil" : "Nenhum aguardando"} atencao={s.pendentes > 0} />
          </div>
        </div>
      )}
    </Kpis>
  );
}
